const LOCAL_SHOP_LOGOS: Record<string, string> = {
  gamersgate: "/shop-logos/gamersgate.svg",
  // Official brand icons, self-hosted (source: each shop's own site icon).
  electronicfirst: "/shop-logos/electronic-first.png",
  cjscdkeys: "/shop-logos/cjs-cdkeys.png",
};

type LogoSource =
  | { slug?: string | null; shopSlug?: string | null; logoUrl?: string | null; shopLogo?: string | null }
  | null
  | undefined;

function normalizeSlug(slug?: string | null): string {
  return (slug ?? "").toLowerCase().replace(/[^a-z0-9]/g, "");
}

export function resolveShopLogoUrl(source: LogoSource): string | null {
  if (!source) return null;
  const slug = normalizeSlug(source.slug ?? source.shopSlug);
  const localLogo = LOCAL_SHOP_LOGOS[slug];
  if (localLogo) return localLogo;
  return source.logoUrl ?? source.shopLogo ?? null;
}

export function shopInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) return `${words[0][0]}${words[1][0]}`.toUpperCase();
  return name.slice(0, 2).toUpperCase();
}